import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Nav from './components/navbar/Nav';
import AboutMe from './components/main/AboutMe';
import MySkills from './components/main/MySkills';
import Projects from './components/main/Projects';
import Contact from './components/main/Contact';
import Box from '@mui/material/Box';
import './App.css';

function App() {

  return (
    <Box sx={{ backgroundColor: '#000' }} className='d-flex'>
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path='/' element={<AboutMe />} />
          <Route path='/myskills' element={<MySkills />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </Box>
  );
}

export default App;
